import { i18n } from "../../../i18n/i18n";

import React, { Component } from 'react'
import { Line } from 'react-chartjs-2'
import { Chart, LineElement, PointElement } from 'chart.js'
import colorUtil from '../../../utils/color.util'
import chartApi, { ChartCasesShippedResponse } from '../../../apis/chart.api'
import itemApi, { ItemData } from '../../../apis/item.api'
import itemService from '../../../services/item.service'
import SearchPicker, { SearchPickerOption } from '../../../components/SearchPicker'
import Icon from '../../../components/Icon'

interface Props { }

interface State extends ChartCasesShippedResponse {
  item: string
  itemId: string
  items: ItemData[]
}

export default class CasesShipped extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      item: '',
      itemId: '',
      dates: [],
      cases: [],
      items: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleSearchSelect = this.handleSearchSelect.bind(this)
    this.handleSearchBlur = this.handleSearchBlur.bind(this)
  }

  get data () {
    const { dates, cases } = this.state
    const color = colorUtil.materialAt(0)
    const data = {
      labels: dates,
      datasets: [
        {
          label: 'Cases',
          data: cases,
          backgroundColor: color,
          borderColor: color
        }
      ]
    }
    return data
  }

  get itemSearchOptions () {
    return itemService.searchOptions(this.state.items)
  }

  get chart () {
    Chart.register(PointElement, LineElement)
    return (
      <Line
        data={this.data}
        options={{
          aspectRatio: 1,
          scales: {
            x: {
              grid: { drawOnChartArea: false }
            },
            y: { beginAtZero: true }
          },
          plugins: {
            title: {
              display: true,
              align: 'center',
              text: i18n('Cases Shipped')
            },
            legend: {
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 10,
                boxHeight: 10
              }
            }
          }
        }}
        className='mb-3' />
    )
  }

  get filterFields () {
    return (
      <SearchPicker
        name="item"
        value={this.state.item}
        options={this.itemSearchOptions}
        label={i18n("Item")}
        onSearch={this.handleSearch}
        onChange={this.handleInputChange}
        onSelect={this.handleSearchSelect}
        onBlur={this.handleSearchBlur} />
    )
  }

  handleInputChange (name: string, value: string) {
    if (name === 'item') this.setState({ itemId: '', item: value })
  }

  handleSearch (name: string, term: string) {
    if (name === 'item') {
      itemApi.search(term, items => {
        if (!items) return
        this.setState({ items })
      })
    }
  }

  handleSearchSelect (name: string, option: SearchPickerOption) {
    if (name === 'item') {
      const { value } = option
      const itemId = String(option.id)
      this.setState({ items: [], item: value, itemId }, () => {
        this.readCasesShipped()
      })
    }
  }

  handleSearchBlur (name: string) {
    if (name === 'item') {
      this.setState({ items: [] })
    }
  }

  handleClear = () => {
    this.setState({
      item: '',
      itemId: ''
    }, () => {
      this.readCasesShipped()
    })
  }

  readCasesShipped () {
    const { itemId } = this.state
    chartApi.casesShipped(itemId, casesShipped => {
      if (!casesShipped) return
      const { dates, cases } = casesShipped
      this.setState({ dates, cases })
    })
  }

  componentDidMount () {
    this.readCasesShipped()
  }

  render () {
    return (
      <div>
        <button
          onClick={this.handleClear}
        >
          <Icon name='refresh' size='medium' color="dark" />
        </button>
        {this.chart}
        {this.filterFields}
      </div>
    )
  }
}
